module.exports = __webpack_public_path__ + "img/raft-demo.57d94c3b.png";